'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _bookAppointment = require('../../src/styles/book-appointment.scss');

var _bookAppointment2 = _interopRequireDefault(_bookAppointment);

require('../../src/styles/external.scss');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { FormattedMessage } from 'react-intl';

var PHONE_NUMBER_LENGTH = 11;
// import messages from '../lang/default-messages';

// TODO: valid for policy and claim numbers
// TODO: vitality styles for button

var validatePhone = function validatePhone(number) {
	return typeof number === 'string' && number.length && number.match(/\d/g).length === PHONE_NUMBER_LENGTH;
};
var validatePolicyNumber = function validatePolicyNumber(number) {
	return typeof number === 'string' && number.length > 0;
};
var validateClaimNumber = function validateClaimNumber(number) {
	return typeof number === 'string' && number.length > 0;
};

var BookAppointment = function BookAppointment(props) {
	return _react2.default.createElement(
		'form',
		{ className: 'form-horizontal ' + props.className },
		_react2.default.createElement(
			'div',
			{ className: _bookAppointment2.default.subheader },
			'Appointment'
		),
		_react2.default.createElement(
			'label',
			{ className: _bookAppointment2.default.appointmentInfo },
			'Specialist:'
		),
		_react2.default.createElement(
			'span',
			null,
			props.specialistName
		),
		_react2.default.createElement('br', null),
		_react2.default.createElement(
			'label',
			{ className: _bookAppointment2.default.appointmentInfo },
			'Practice:'
		),
		_react2.default.createElement(
			'span',
			null,
			props.practiceName
		),
		_react2.default.createElement('br', null),
		_react2.default.createElement(
			'label',
			{ className: _bookAppointment2.default.appointmentInfo },
			'For:'
		),
		_react2.default.createElement(
			'span',
			null,
			props.appointmentDatetime
		),
		_react2.default.createElement(
			'div',
			{ className: _bookAppointment2.default.sectionContainer },
			_react2.default.createElement(
				'div',
				{ className: _bookAppointment2.default.subheader + ' ' + _bookAppointment2.default.yourDetails },
				'Your details'
			),
			_react2.default.createElement(
				'div',
				{ className: _bookAppointment2.default.footnotes },
				'* indicates required field'
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group ' + _bookAppointment2.default.inputContainer },
						_react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
						_react2.default.createElement('input', { className: 'form-control ' + (!props.validClaimNumber && props.submitFailed ? _bookAppointment2.default.error : ''),
							placeholder: 'Claim number *',
							value: props.requestData.patient_claim_number,
							onChange: function onChange(event) {
								props.onClaimNumberChange(event.target.value);
								props.setValidClaimNumber(validateClaimNumber(event.target.value));
							},
							required: true
						})
					),
					_react2.default.createElement('i', { className: _bookAppointment2.default.tooltipIcon + ' ion-information-circled' }),
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.modalTooltipContainer + ' ' + _bookAppointment2.default.tooltipContainer },
						_react2.default.createElement(
							'strong',
							null,
							'Why?'
						),
						' This is used to match your claim to your appointment.'
					),
					!props.validClaimNumber && props.submitFailed && _react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.errorMessage },
						'Please enter a valid claim number.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group ' + _bookAppointment2.default.inputContainer },
						_react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
						_react2.default.createElement('input', { className: 'form-control ' + (!props.validPolicyNumber && props.submitFailed ? _bookAppointment2.default.error : ''),
							placeholder: 'Membership number *',
							value: props.requestData.patient_policy_number,
							onChange: function onChange(event) {
								props.onPolicyNumberChange(event.target.value);
								props.setValidPolicyNumber(validatePolicyNumber(event.target.value));
							},
							required: true
						})
					),
					_react2.default.createElement('i', { className: _bookAppointment2.default.tooltipIcon + ' ion-information-circled' }),
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.modalTooltipContainer + ' ' + _bookAppointment2.default.tooltipContainer },
						_react2.default.createElement(
							'strong',
							null,
							'Why?'
						),
						' This is used to identify your policy.'
					),
					!props.validPolicyNumber && props.submitFailed && _react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.errorMessage },
						'Please enter a valid membership number.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group ' + _bookAppointment2.default.inputContainer },
						_react2.default.createElement('i', { className: 'ion-ios-telephone' }),
						_react2.default.createElement('input', { className: 'form-control ' + (!props.validPhone && props.submitFailed ? _bookAppointment2.default.error : ''),
							placeholder: 'Phone *',
							onChange: function onChange(event) {
								props.onPhoneChange(event.target.value);
								props.setValidPhone(validatePhone(event.target.value));
							},
							required: true
						})
					),
					_react2.default.createElement('i', { className: _bookAppointment2.default.tooltipPhone + ' ' + _bookAppointment2.default.tooltipIcon + ' ion-information-circled' }),
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.modalTooltipContainer + ' ' + _bookAppointment2.default.tooltipContainerPhone },
						_react2.default.createElement(
							'strong',
							null,
							'Why?'
						),
						' We use your number to contact you about your booked appointment.'
					),
					!props.validPhone && props.submitFailed && _react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.errorMessage },
						'Please enter a valid phone number.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.label },
						'Have you visited this specialist before? *'
					),
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group ' + _bookAppointment2.default.selectContainer + ' ' + _bookAppointment2.default.inputContainer },
						_react2.default.createElement(
							'select',
							{ className: 'form-control ' + _bookAppointment2.default.select + ' ' + (!props.validVisitedOption && props.submitFailed ? _bookAppointment2.default.error : ''),
								defaultValue: '',
								onChange: function onChange(event) {
									(0, _doctifyUtils.fireGTMevent)('patient_booking_yesno_step3', event.target.value);
									props.onVisitedOptionSelected(event.target.value);
								},
								required: true },
							_react2.default.createElement(
								'option',
								{ disabled: true, value: '' },
								'Please select *'
							),
							_react2.default.createElement(
								'option',
								{ value: 'y' },
								'Yes'
							),
							_react2.default.createElement(
								'option',
								{ value: 'n' },
								'No'
							)
						),
						_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
					),
					_react2.default.createElement('i', { className: _bookAppointment2.default.tooltipTallInput + ' ' + _bookAppointment2.default.tooltipIcon + ' ion-information-circled' }),
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.modalTooltipContainer + ' ' + _bookAppointment2.default.tooltipContainerVisited },
						_react2.default.createElement(
							'strong',
							null,
							'Why?'
						),
						' We use this information to let the specialist know you are a returning patient.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12 col-md-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group textarea ' + _bookAppointment2.default.textareaContainer + ' ' + _bookAppointment2.default.inputContainer },
						_react2.default.createElement('textarea', { className: 'form-control',
							placeholder: 'Reason for visit',
							onChange: function onChange(event) {
								props.onVisitReasonChange(event.target.value);
							}
						})
					),
					_react2.default.createElement('i', { className: _bookAppointment2.default.tooltipReasonForVisit + ' ' + _bookAppointment2.default.tooltipIcon + ' ion-information-circled' }),
					_react2.default.createElement(
						'div',
						{ className: _bookAppointment2.default.modalTooltipContainer + ' ' + _bookAppointment2.default.tooltipContainerReasonForVisit },
						_react2.default.createElement(
							'strong',
							null,
							'Why?'
						),
						' Let us know why you are visiting so that the specialist can better serve you.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.actions },
				_react2.default.createElement(
					'div',
					{ className: 'form-group' },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'button',
							{ className: 'btn ' + _bookAppointment2.default.btnSubmit,
								type: 'button',
								onClick: function onClick() {
									if (validatePhone(props.requestData.patient_contact_telephone) && validateClaimNumber(props.requestData.patient_claim_number) && validatePolicyNumber(props.requestData.patient_policy_number) &&
									// props.requestData.insurance_type !== '' &&  (no insurance for vitality)
									props.requestData.appointment_type !== '') {
										props.submitAppointmentRequest(props.requestData).then(function () {
											(0, _doctifyUtils.fireGTMevent)('lead_submit_patient_booking');
										});
									} else {
										props.validationError();
									}
								} },
							'Submit'
						),
						_react2.default.createElement(
							'button',
							{ className: 'btn ' + _bookAppointment2.default.btnCancel,
								type: 'button',
								onClick: function onClick() {
									return props.onCancel();
								} },
							'Cancel'
						)
					)
				)
			)
		)
	);
};

BookAppointment.propTypes = {
	requestData: require('react').PropTypes.object.isRequired,
	specialistName: require('react').PropTypes.any.isRequired,
	appointmentDatetime: require('react').PropTypes.any.isRequired,
	insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired,
		name: require('react').PropTypes.any.isRequired
	})).isRequired,
	className: require('react').PropTypes.any,
	submitFailed: require('react').PropTypes.any.isRequired,
	validPhone: require('react').PropTypes.any.isRequired,
	validPolicyNumber: require('react').PropTypes.any.isRequired,
	validClaimNumber: require('react').PropTypes.any.isRequired,
	validVisitedOption: require('react').PropTypes.any.isRequired,
	validInsurer: require('react').PropTypes.any.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onPolicyNumberChange: require('react').PropTypes.func.isRequired,
	onClaimNumberChange: require('react').PropTypes.func.isRequired,
	onVisitedOptionSelected: require('react').PropTypes.func.isRequired,
	onInsuranceSelected: require('react').PropTypes.func.isRequired,
	onVisitReasonChange: require('react').PropTypes.func.isRequired,
	submitAppointmentRequest: require('react').PropTypes.func.isRequired,
	onCancel: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	setValidPhone: require('react').PropTypes.func.isRequired,
	setValidPolicyNumber: require('react').PropTypes.func.isRequired,
	setValidClaimNumber: require('react').PropTypes.func.isRequired
};
BookAppointment.displayName = 'BookAppointment';

BookAppointment.defaultProps = {
	patient: {},
	insurers: []
};

exports.default = BookAppointment;


// WEBPACK FOOTER //
// ./components/book-appointment/lib/components/book-appointment.js